import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { FormattedMessage } from "react-intl"

const EmptyProductBundleComponent = () => {
    return <Container>
        <Row>
            <Col>
                <p className="h3 text-center text-custom-primary mt-3 mb-3">
                    <FormattedMessage
                        id="product.bundles.forms.bundle_composition_form.no_bundle_yet_title"
                        defaultMessage="Empty product bundle!"
                    />
                </p>
                <p className="h6 text-center mb-3">
                    <FormattedMessage
                        id="product.bundles.forms.bundle_composition_form.no_bundle_yet_message"
                        defaultMessage="You have not yet added any products to your bundle."
                    />
                </p>
            </Col>
        </Row>
    </Container>
}

export default EmptyProductBundleComponent


// WEBPACK FOOTER //
// ./src/product/bundle/components/EmptyProductBundleComponent.tsx